import { IListBoxItem, ListBoxItemType } from "azure-devops-ui/ListBox";

export const groupedItems: IListBoxItem[] = [
    { id: "group1", text: "Group 1", type: ListBoxItemType.Header, groupId: "first" },
    { id: "group2", text: "Group 2", type: ListBoxItemType.Header, groupId: "second" },
    { id: "group3", text: "Group 3", type: ListBoxItemType.Header, groupId: "third" },
    { id: "first", text: "first", groupId: "first" },
    { id: "second", text: "second", groupId: "second" },
    { id: "divider", type: ListBoxItemType.Divider, groupId: "second" },
    { id: "divider2", type: ListBoxItemType.Divider, groupId: "third" },
    { id: "third", text: "third", groupId: "third" },
    { id: "fourth", text: "fourth", groupId: "fourth" },
    { id: "divider3", type: ListBoxItemType.Divider, groupId: "fourth" },
    { id: "fifth", text: "fifth", groupId: "fourth" }
];

export const groups = [
    { id: "first" },
    { id: "second" },
    { id: "third" },
    { id: "fourth", name: "Group 4" }
];

export const statusItems: IListBoxItem[] = [
    { id: "available", text: "available" },
    { id: "offline", text: "offline" },
    { id: "booting", text: "booting" }
];

export const singleListItems = [
    "Item 1",
    "Item 2",
    "Item 3",
    "Really really really really really really really really really really really really really long item"
];

export const multiListItems = [
    "Item 4",
    "Item 5",
    "Item 6",
    "Item 14",
    "Item 15",
    "Item 16",
    "Item 24",
    "Item 25",
    "Item 26",
    "Really really really really really really really really really really really really really long item"
];
